import { createApiInstance, LONG_TIMEOUT_CONFIG } from './config'

const api = createApiInstance()
const longApi = createApiInstance(LONG_TIMEOUT_CONFIG)

export const questionBankAPI = {
  list(page = 1, pageSize = 20, keyword = null) {
    const params = { page, pageSize }
    if (keyword != null && String(keyword).trim()) {
      params.keyword = String(keyword).trim()
    }
    return api.get('/question-bank/list', { params })
  },

  /** 获取全部题目与答案（不分页） */
  getAll() {
    return api.get('/question-bank/all')
  },

  save(data) {
    return api.post('/question-bank/save', data)
  },

  batchSave(items) {
    return api.post('/question-bank/batch-save', items)
  },

  delete(id) {
    return api.delete(`/question-bank/${id}`)
  },

  recognizeImage(file) {
    const formData = new FormData()
    formData.append('file', file)
    return longApi.post('/question-bank/recognize-image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  }
}

export default questionBankAPI
